export default __webpack_public_path__ + "static/media/quiz.facef552.PNG";